/* eslint-disable no-case-declarations */
import { ADD_BNG_PURPOSE, REMOVE_BNG_PURPOSE } from '../mainActionTypes';

export default function purposeReducer(state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_BNG_PURPOSE:
      const purpose = state.purpose || [];
      purpose.push(payload.purpose);
      const currentAllState = { ...state, purpose };
      return currentAllState;
    case REMOVE_BNG_PURPOSE:
      let purposeList = state.purpose;
      const index = purposeList.indexOf(payload.purpose);
      if (index > -1) {
        purposeList.splice(index, 1);
        purposeList = [...purposeList];
      }
      const newState = { ...state, purpose: purposeList };
      return newState;

    default:
      return state;
  }
}
